import { EMAIL_REG, PASS_REG, PASS_STRONG_REG } from '../constants';
import { ValidatorType } from '../../common';

export const emailValidator: ValidatorType = (val) => {
	return EMAIL_REG.test(val);
};

export const passValidator: ValidatorType = (val) => {
	return PASS_REG.test(val);
};

export const passFairValidator: ValidatorType = (val) => {
	return !PASS_REG.test(val);
};

export const passStrongValidator: ValidatorType = (val) => {
	return !PASS_STRONG_REG.test(val);
};

export const usernameValidator: ValidatorType = (val) => {
	return val.length >= 3;
};
